import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GradienButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_GRADIEN_BUTTONS, EDGE_GRADIEN_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeGradienButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={GradienButton} span={EDGE_GRADIEN_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn color="primary-gradien" id="Tooltip-75" className="btn-pill">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-75" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary-gradien</ToolTip>
          {EDGE_GRADIEN_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} />
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeGradienButtons;
